import React from "react";
import { Link } from "react-router-dom";

const CompanyStory = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-catalina-blue mb-6">
              Our Story
            </h2>
            <p className="text-gray-600 mb-6 text-lg leading-relaxed">
              An unexpected end in one chapter became the foundation of a new
              beginning the creation of Trolift. Built on the values of
              quality, reliability, and customer-first service, Trolift offers a
              range of Telescopic Ladders, Platform Trolleys, and Pallet Trucks
              designed for both commercial and residential needs. The company is
              led by Rakesh Sharma, whose industry experience drives operational
              excellence, and backed by Pratik Kathuria as a consultant,
              bringing strategic expertise in sales, supply chain, and business
              growth. Together, the team ensures that every Trolift product
              delivers the right price, lasting value, and dependable
              performance — serving customers better than ever before.
            </p>
            <Link
              to="/products"
              className="inline-block bg-catalina-blue text-white px-8 py-3 rounded-md font-semibold hover:bg-san-marino transition duration-300"
            >
              View Our Products
            </Link>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <div className="flex justify-center mb-4 overflow-hidden rounded-lg">
              <img
                src="/our-story.jpg"
                alt="Our Expertise - Professional Team"
                className="w-full h-64 object-cover"
              />
            </div>
            <h3 className="text-2xl font-bold text-catalina-blue text-center mb-4">
              Our Expertise
            </h3>
            <p className="text-gray-600 text-center text-lg">
              Years of experience in delivering quality material handling
              solutions
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyStory;
